import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { CustomerState, CustomerStore } from './customer.store';
import { Observable } from 'rxjs';
import { ContactModel } from '@railmybox/api-user';

@Injectable({ providedIn: 'root' })
export class CustomerQuery extends Query<CustomerState> {
  constructor() {
    const store = inject(CustomerStore);
    super(store);
  }

  getRegistrationStep(): string {
    return this.getValue().registrationStep;
  }

  /**
   * Retrieves a single customer attribute from the store by name.
   */
  getCustomerAttribute<K extends keyof CustomerState>(attribute: K): CustomerState[K] {
    return this.getValue()[attribute];
  }

  /**
   * Retrieves a customer from the store.
   */
  getCustomer(): CustomerState {
    return this.getValue();
  }

  getRmbAuth(): Observable<boolean> {
    return this.select('rmbAuthorized');
  }

  getContacts(): ContactModel[] {
    return this.getValue().contacts as ContactModel[];
  }
}
